import type { KpiCardSpec } from './card-spec';

/**
 * The Total users scalar, shown on the Acquisition page's Pulse row and the
 * Users page's User acquisition section. One object in two catalogs, so the
 * two pages cannot report different figures for the same KPI.
 */
export const TOTAL_USERS_SCALAR_CARD: KpiCardSpec = {
    title: 'Total users',
    source: 'total-users',
    metric: 'totalUsers',
    form: 'number',
    size: 'sm',
    description:
        'Every account created and not yet deleted, as of the end of the selected period. The start date does not move it.',
};
